export default __webpack_public_path__ + "locales/ko-KR/JavascriptSdk.json?hash=b43a609f5264b534c0e61c355d807b95";